import { DeepPartial } from 'utility-types';
import { ConceptName } from '../types/ConceptName';
import { DataRoleModel } from '../types/DataRoleModel';
import { DataType } from '../types/DetailEnums';
import { ValueConcept } from '../types/ValueConcept';
import { getCookie } from '../../tag/TagUtils';

// WebclientApis serialize using camel case rather than underscores, so we need this variant type
export type DataRoleFieldSynonymWebClient = Exclude<ConceptName, 'is_primary'> & {
  readonly isPrimary: boolean;
};

export type DataRoleUpdateModel = DeepPartial<DataRoleModel>;

export const updateDataroleApi = (luid: string, updateModel: DataRoleUpdateModel): Promise<Response> => {
  if (!luid) { return Promise.reject(); }
  const TagHeaders = new Headers({ 'X-XSRF-TOKEN': getCookie('XSRF-TOKEN'), 'Content-Type': 'application/json' });

  const targetUrl = `${window.location.origin}/services/semantic-model/data-roles/${luid}`;
  return fetch(targetUrl, {
    body: JSON.stringify(updateModel),
    headers: TagHeaders,
    method: 'PATCH',
    cache: 'no-cache',
    credentials: 'include',
  });
};
